import CareerPlanningLevels from 'builder/components/CareerPlanningLevels'
import CareerPlanningProgress from 'builder/components/CareerPlanningProgress'

import { FoldableContainer } from '../../styles'

type Props = {
  score: number
  open: boolean
  isPhone: boolean
  handleClick: () => void
  containerRef?: React.RefObject<HTMLDivElement>
}

const MainContent = ({ score, isPhone, open, handleClick, containerRef }: Props) => {
  return (
    <FoldableContainer $isOpen={open} ref={containerRef}>
      <CareerPlanningProgress score={score} isOpen={open} isDeskTop={false} isMobile={isPhone} />
      <CareerPlanningLevels handleClick={handleClick} />
    </FoldableContainer>
  )
}

export default MainContent
